import {doc_changeCodiDocumentRowType_Api} from 'apis'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {NullAsDefault} from 'views/Shared'
import {CodiContentTypes} from './codiHelpers'
import {SelectWidget} from '../custom/ReactSelectComponents'
import {notifyOnError} from '../factory/createErrorEvent'
import {createControlledFormField} from '../factory/createFormField'
import {NotificationActionTypes, successNotify,} from '../factory/createNotification'
import {bindQueryParams} from '../functions/routerHelper'
import RowSettingContext, {SettingRowHeader} from './RowSettingContext'
import LoadingBlock from "../../LoadingBlock";

const UpdateRowType = ({
                           style,
                           className,
                           onCancel = NullAsDefault,
                           onSuccess = NullAsDefault,
                       }) => {
    const t = useTranslate()

    const {
        item,
        row_id,
        codi_id,
        isLoading = false,
    } = useContext(RowSettingContext)

    const {handleAsyncAction = NullAsDefault} = useAsyncAction({
        apiInfo: doc_changeCodiDocumentRowType_Api,
        query: bindQueryParams([{id: codi_id}, {row_id}]),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onSuccess()
        },
        onError: notifyOnError(t),
    })

    const handleSubmit = async (values, {setSubmitting = NullAsDefault}) => {
        const {index_cd, index_typecd} = values ?? {}
        setTimeout(() => {
            setSubmitting(true)
            handleAsyncAction({
                index_cd,
                index_typecd,
            })
        })
    }

    const initialValues = useMemo(
        () => ({
            index_typecd: undefined,
            index_cd: item?.index_cd,
            current_index_typecd: item?.index_typecd,
        }),
        [item]
    )

    const options = useMemo(
        () =>
            _.filter(
                [
                    CodiContentTypes.SUB_CHAPTER,
                    CodiContentTypes.CHAPTER,
                    CodiContentTypes.SUPER_CHAPTER,
                    CodiContentTypes.APPENDIX,
                    CodiContentTypes.SUB_SECTION,
                    CodiContentTypes.SECTION,
                    CodiContentTypes.SUPER_SECTION,
                    CodiContentTypes.ARTICLE,
                    CodiContentTypes.CLAUSE,
                    CodiContentTypes.POINT,
                    CodiContentTypes.PART,
                    CodiContentTypes.CONTENT,
                ].map((value) => ({value, label: t(value)})),
                ({value}) => value !== item?.index_typecd
            ),
        [item.index_typecd]
    )

    return (
        <Formik
            validate={(values) => {
                let errors = {}
                if (!values?.index_typecd) {
                    errors.index_typecd = t('required field')
                }
                return errors
            }}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            initialValues={initialValues}>
            <div
                style={style}
                className={classNames(
                    'flex flex-col flex-1 px-8 custom-form-codi',
                    className
                )}>
                <div className="w-full flex flex-col">
                    <div className="flex justify-center font-bold text-color-000 text-xl uppercase mb-4">
                        {t('change type index typecd')}
                    </div>
                    {isLoading ? (
                        <LoadingBlock/>
                    ) : (
                        <React.Fragment>
                            <SettingRowHeader/>
                            <FieldsFactory
                                formSchema={[
                                    {
                                        title: 'type of index',
                                        children: {
                                            name: 'index_typecd',
                                            component: ({name, value, onChange}) => (
                                                <SelectWidget
                                                    name={name}
                                                    value={value}
                                                    options={options}
                                                    allowClear={true}
                                                    className="w-full"
                                                    placeholder={
                                                        <span className="text-xs italic text-color-400">
                              {t('ex:type-cd')}
                            </span>
                                                    }
                                                    onChange={(value) => {
                                                        onChange(createValue(name, value))
                                                    }}
                                                />
                                            ),
                                        },
                                    },
                                ]}
                            />
                            <FieldsFactory
                                formSchema={[
                                    {
                                        title: 'index number',
                                        children: {
                                            name: 'index_cd',
                                            component: createControlledFormField({
                                                placeholder: 'index number',
                                            }),
                                        },
                                    },
                                ]}
                            />
                        </React.Fragment>
                    )}
                </div>
                <div className="flex-1"/>
                <FormActionBar className="background"/>
            </div>
        </Formik>
    )
}

export default UpdateRowType
